import { FC, useCallback } from 'react';
import { MdEdit as Edit } from 'react-icons/md';
import { Box, IconButton, lighten, Typography, useTheme } from '@mui/material';

const OwnerSection: FC<React.PropsWithChildren<OwnerSectionProps>> = ({
  appId,
  editable,
  title,
  children,
  onEdit,
}) => {
  const theme = useTheme();
  const handleEdit = useCallback(() => {
    onEdit && appId && onEdit(appId);
  }, [onEdit, appId]);

  return (
    <div>
      <Box display='flex' alignItems='center' gap={1}>
        <Typography variant='body2' color='text.secondary' whiteSpace='nowrap'>
          {title}
        </Typography>
        <IconButton
          size='small'
          onClick={handleEdit}
          sx={{
            visibility: editable ? 'visible' : 'hidden',
            fontSize: '0.9rem',
          }}>
          <Edit
            fontSize='inherit'
            style={{ color: lighten(theme.palette.primary.main, 0.5) }}
          />
        </IconButton>
      </Box>
      <Box mt={1}>{children}</Box>
    </div>
  );
};

export interface OwnerSectionProps {
  title: string;
  editable?: boolean;
  appId?: string;
  onEdit?: (appId: string) => void;
}

export default OwnerSection;
